/**
 * Render-side guard for user-supplied URLs (currently sys_app.app_icon).
 *
 * The backend already rejects anything that is not an absolute https URL
 * (see _validate_https_url_optional in resource/myapps.py), but rows can also
 * be written straight to the database via Adminer, and older rows predate that
 * validator. Anything we hand to an <img src> is checked here as well.
 *
 * Absolute https only — `javascript:`, `data:` and relative values all fall
 * back to undefined, which makes <Avatar> render its text child instead.
 */
export function safeImageUrl(raw) {
    if (!raw) return undefined;
    let parsed;
    try {
        // No base URL on purpose: relative strings must fail rather than
        // silently resolve against the current origin.
        parsed = new URL(String(raw));
    } catch (e) {
        return undefined;
    }
    return parsed.protocol === 'https:' ? parsed.href : undefined;
}

export default safeImageUrl;
